module.exports = __webpack_public_path__ + "assets/svg/play_icon.svg";